import { jsx as o } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ o("path", { d: "M6 9L12 15L18 9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" });
export {
  t as default
};
